import { useEffect, useState } from 'react';
import { useStorefrontInfoContext_UNSAFE } from '../x4ec/provider/storefront-info/useStorefrontInfo';
import { useBuildVars } from './build-config';

const X4C_DEFAULT_PAGE_TITLE = 'Xvantage';

/** updatePageTitle: Sets page title for the consuming View component as the input string.
 * For setting page title on iFramed pages, see:
 * https://imonline.atlassian.net/wiki/spaces/DigitalT/pages/3070820435/X4C+Page+Titles#iFramed-Pages */
export function usePageTitle() {
  const { appId } = useBuildVars();
  const storefrontInfoContext = useStorefrontInfoContext_UNSAFE();
  const [title, setTitle] = useState<string | null>(null);

  const updatePageTitle = (newTitle: string) => {
    if (newTitle && title !== newTitle) {
      setTitle(newTitle);
    }
  };

  let pageTitle: string;
  let defaultPageTitle: string;
  if (appId === 'x4ec') {
    const storefrontName = `${
      storefrontInfoContext?.displayName ?? ''
    } Storefront`;

    defaultPageTitle = storefrontName;
    pageTitle = title ? `${title} - ${storefrontName}` : storefrontName;
  } else {
    defaultPageTitle = X4C_DEFAULT_PAGE_TITLE;
    pageTitle = title ? title : X4C_DEFAULT_PAGE_TITLE;
  }

  useEffect(() => {
    document.title = pageTitle;
    return () => {
      document.title = defaultPageTitle;
    };
  }, [pageTitle, defaultPageTitle]);

  return { pageTitle, updatePageTitle };
}
